var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTabletOutline = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 10a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 4.67c0-.535 0-.98-.03-1.345-.03-.38-.098-.736-.27-1.073A2.75 2.75 0 0 0 16.25 1.05c-.338-.172-.694-.24-1.074-.27-.365-.03-.81-.03-1.345-.03H4.17c-.535 0-.98 0-1.345.03-.38.03-.736.098-1.073.27A2.75 2.75 0 0 0 .55 2.252c-.172.337-.24.693-.27 1.073-.03.365-.03.81-.03 1.345v6.66c0 .535 0 .98.03 1.345.03.38.098.736.27 1.073a2.75 2.75 0 0 0 1.202 1.202c.337.172.693.24 1.073.27.365.03.81.03 1.345.03h9.66c.535 0 .98 0 1.345-.03.38-.03.736-.098 1.073-.27a2.751 2.751 0 0 0 1.202-1.201c.172-.338.24-.694.27-1.074.03-.365.03-.81.03-1.345V4.67Zm-1.636-1.737c.046.09.088.227.111.514.024.296.025.68.025 1.253v6.6c0 .572 0 .957-.025 1.252-.023.288-.065.425-.111.516a1.25 1.25 0 0 1-.546.546c-.091.046-.228.088-.515.111-.296.024-.68.025-1.253.025H4.2c-.572 0-.957 0-1.253-.025-.287-.023-.424-.065-.514-.111a1.25 1.25 0 0 1-.547-.546c-.046-.091-.088-.228-.111-.515-.024-.296-.025-.68-.025-1.253V4.7c0-.572 0-.957.025-1.253.023-.287.065-.424.111-.514a1.25 1.25 0 0 1 .547-.547c.09-.046.227-.088.514-.111.296-.024.68-.025 1.253-.025h9.6c.572 0 .957 0 1.252.025.288.023.425.065.516.111.235.12.426.311.546.547Z",
    fill: "currentColor"
  })));
};
export default SvgTabletOutline;